import React, { useEffect } from 'react';
import { Route, Routes, Navigate, useNavigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { CloseButton, Fade } from '../components/common/Toast';
import { Card, CardBody, Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Landing from '../cmtComponents/landing/Landing';
import ErrorLayout from './ErrorLayout';

// Private Route - secured with Auth0
import PrivateRoute from "../cmtComponents/auth0/PrivateRoute";
import { useAuth0 } from "../cmtComponents/auth0/react-auth0-spa";

import loadable from '@loadable/component';
const MainAppLayout = loadable(() => import('./MainAppLayout'));
const WizardLayout = loadable(() => import('../cmtComponents/signup/wizard/WizardLayout'));
const JoinWizardLayout = loadable(() => import('../cmtComponents/signup/joinwizard/JoinWizardLayout'));
const AuthBasicLayout = loadable(() => import('../cmtLayouts/AuthBasicLayout'));

const Layout = () => {
  const { authError, clearAuthError } = useAuth0();
  const navigate = useNavigate();

  useEffect(() => {
    MainAppLayout.preload();
  }, []);

  // Auth0 always redirects back to the app origin ("/"), which is a public
  // route not covered by PrivateRoute, so a failed login (eg a Rule that
  // errors or times out) needs to be surfaced here to be seen at all.
  if (authError) {
    return (
      <Card className="text-center">
        <CardBody className="p-5">
          <div className="display-1 text-200 fs-error">!</div>
          <p className="lead mt-4 text-800 text-sans-serif fw-semibold">
            Authentication Error
          </p>
          <hr />
          <p>{authError}</p>
          <Button color="primary" size="sm" className="mt-3 me-2" onClick={() => window.location.reload()}>
            <FontAwesomeIcon icon="redo" className="me-2" />
            Try Again
          </Button>
          <Button
            color="secondary"
            size="sm"
            className="mt-3"
            onClick={() => {
              clearAuthError();
              navigate('/');
            }}
          >
            <FontAwesomeIcon icon="home" className="me-2" />
            Back to Home
          </Button>
        </CardBody>
      </Card>
    );
  }

  return (
    <>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/errors/*" element={<ErrorLayout />} />
        <Route path="/signup/examplewizard" element={<WizardLayout />} />
        <Route path="/signup" element={<JoinWizardLayout />} />
        <Route path="/signup/:id" element={<JoinWizardLayout />} />
        <Route path="/verifyemail" element={<PrivateRoute><AuthBasicLayout /></PrivateRoute>} />
        <Route path="/*" element={<PrivateRoute><MainAppLayout /></PrivateRoute>} />
      </Routes>
      <ToastContainer transition={Fade} closeButton={<CloseButton />} position="bottom-left" />
    </>
  );
};

export default Layout;
